<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="报名人ID" :value="1"></el-option>
                            <el-option label="报名人昵称" :value="2"></el-option>
                            <el-option label="手机号" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="报名提交时间" :value="1"></el-option>
                                <el-option label="报名修改时间" :value="2"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="daterange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            align="right"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div v-if="$utils.have('/festival/springSeed/export')" class="page-btns-box">
            <el-button type="primary" icon="el-icon-download" size="small" @click="exportData" :loading="exportLoading">导出</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="name" label="音乐人名称" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="telephone" label="填写手机号" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="wechat" label="微信号" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="styleName" label="音乐风格" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="talentAgencyInfo" label="是否已签约厂牌/公司" min-width="150"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="descInfo" label="自我介绍" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="birthDate" label="组建年份" width="100"></el-table-column>
                <el-table-column label="演出照片" min-width="100">
                    <template slot-scope="scope">
                        <el-image v-if="scope.row.imageUrl.length == 1"
                            :src="scope.row.imageUrl[0] | coverImage(120, 120)" fit="cover"
                            :preview-src-list="[scope.row.imageUrl[0]]"></el-image>
                        <el-button v-else-if="scope.row.imageUrl.length > 1" type="text" size="mini"
                            @click="previewImg(scope.row.imageUrl, scope.row.name + '-演出照片')">多图</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="宣传照片" min-width="100">
                    <template slot-scope="scope">
                        <el-image v-if="scope.row.avatarUrl.length == 1"
                            :src="scope.row.avatarUrl[0] | coverImage(120, 120)" fit="cover"
                            :preview-src-list="[scope.row.avatarUrl[0]]"></el-image>
                        <el-button v-else-if="scope.row.avatarUrl.length > 1" type="text" size="mini"
                            @click="previewImg(scope.row.avatarUrl, scope.row.name + '-宣传照片')">多图</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="talentVideoUrl" label="视频" min-width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.talentVideoUrl.length == 1" class="video-cover"
                            @click="playVideo(scope.row.talentVideoUrl[0])">
                            <span class="el-icon-video-play"></span>
                        </div>
                        <el-button v-else-if="scope.row.talentVideoUrl.length > 1" type="text" size="mini"
                            @click="previewVideo(scope.row.talentVideoUrl, scope.row.name + '-视频')">查看视频</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="originalUrl" label="流媒体链接" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="supplementaryInfo" label="其他资料" min-width="200"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="userId" label="报名人ID" width="90"></el-table-column>
                <el-table-column prop="accountTelephone" label="账号手机号" min-width="120"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="certName" label="账号实名" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="certNo" label="实名证件" min-width="160" show-overflow-tooltip></el-table-column>
                <el-table-column prop="socialAccountInfo" label="社交媒体账号链接" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="memberInfo" label="音乐人人数" min-width="90"></el-table-column>
                <el-table-column prop="city" label="城市" min-width="90" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTimeStr" label="报名提交时间" min-width="160"></el-table-column>
                <el-table-column prop="modifyTimeStr" label="报名修改时间" min-width="160"></el-table-column>
                <el-table-column fixed="right" label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" icon="el-icon-view" @click="showDetail(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>

        <el-dialog :visible.sync="photoListView" :title="photoName" center append-to-body>
            <div class="preview-box">
                <el-image style="width: 100px; height: 100px;margin: 10px;" v-for="(image, index) in photoList"
                    fit="cover" :src="image | coverImage(200, 200)"
                    :preview-src-list="photoList.slice(index).concat(photoList.slice(0, index))" :key="index">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                </el-image>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="vListView" :title="vName" center append-to-body>
            <div class="preview-box">
                <div class="video-cover" v-for="(video, index) in vList" :key="index"
                    @click="playVideo(video)">
                    <span class="el-icon-video-play"></span>
                </div>
            </div>
        </el-dialog>
        <VideoPlay ref="videoPlay"></VideoPlay>
        <el-drawer v-if="drawerData"
            :title="drawerData.name || '报名详情'"
            :visible.sync="drawerVisible"
            :wrapperClosable="false"
            :destroy-on-close="true"
            direction="rtl"
            size="560px">
            <div class="drawer-content">
                <el-descriptions :column="2" border size="small" direction="vertical">
                    <el-descriptions-item label="报名人ID">{{ drawerData.userId }}</el-descriptions-item>
                    <el-descriptions-item label="音乐人名称">{{ drawerData.name }}</el-descriptions-item>
                    <el-descriptions-item label="账号实名">{{ drawerData.certName || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="实名证件">{{ drawerData.certNo || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="账号手机号">{{ drawerData.accountTelephone || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="填写手机号">{{ drawerData.telephone || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="微信号">{{ drawerData.wechat || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="组建年份">{{ drawerData.birthDate || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="音乐人人数">{{ drawerData.memberInfo || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="城市">{{ drawerData.city || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="音乐风格" :span="2">{{ drawerData.styleName || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="是否已签约厂牌/公司" :span="2">{{ drawerData.talentAgencyInfo || '-'}}</el-descriptions-item>
                    <el-descriptions-item label="自我介绍" :span="2">{{ drawerData.descInfo || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="演出照片" :span="2" v-if="drawerData.imageUrl && drawerData.imageUrl.length">
                        <div class="detail-images">
                            <el-image v-for="(img, idx) in drawerData.imageUrl" :key="idx"
                                :src="img | coverImage(120,120)" fit="cover"
                                :preview-src-list="drawerData.imageUrl" class="detail-img"></el-image>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="宣传照片" :span="2" v-if="drawerData.avatarUrl && drawerData.avatarUrl.length">
                        <div class="detail-images">
                            <el-image v-for="(img, idx) in drawerData.avatarUrl" :key="idx"
                                :src="img | coverImage(120,120)" fit="cover"
                                :preview-src-list="drawerData.avatarUrl" class="detail-img"></el-image>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="视频" :span="2" v-if="drawerData.talentVideoUrl && drawerData.talentVideoUrl.length">
                        <div class="detail-videos">
                            <div class="video-cover-sm" v-for="(video, idx) in drawerData.talentVideoUrl" :key="idx"
                                @click="playVideo(video)">
                                <span class="el-icon-video-play"></span>
                            </div>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="流媒体链接" :span="2">{{ drawerData.originalUrl || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="社交媒体账号链接" :span="2">{{ drawerData.socialAccountInfo || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="其他资料" :span="2">{{ drawerData.supplementaryInfo || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="报名提交时间">{{ drawerData.createTimeStr }}</el-descriptions-item>
                    <el-descriptions-item label="报名修改时间">{{ drawerData.modifyTimeStr }}</el-descriptions-item>
                </el-descriptions>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import { downloadFileTmp } from '@/assets/js/commonApi';
import VideoPlay from "@/components/VideoPlay";
const defaultParams = {
    pageNo: 1,
    searchValue: '',
    searchType: 1,
    startTime: '',
    endTime: '',
    timeType: 1
}

export default {
    components: {
        VideoPlay
    },
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
                startTime: this.$route.query.startTime || '',
                endTime: this.$route.query.endTime || '',
                timeType: parseInt(this.$route.query.timeType || 1)
            },
            listLoading: true,
            exportLoading: false,
            datetimerange: [this.$route.query.startTime || '', this.$route.query.endTime || ''],

            photoList: [],
            photoListView: false,
            photoName: '演出照片',

            vList: [],
            vListView: false,
            vName: '视频',

            drawerVisible: false,
            drawerData: null
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        getDataList() {
            this.params = {
                ...this.params,
                startTime: this.datetimerange && this.datetimerange[0] || '',
                endTime: this.datetimerange && this.datetimerange[1] || ''
            }
            this.listLoading = true;
            this.$request({
                url: '/festival/springSeed/list',
                method: 'POST',
                data: {
                    ...this.params
                }
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                        this.dataList.map(item => {
                            item.imageUrl = item.imageUrl? item.imageUrl.split(',') : [];
                            item.avatarUrl = item.avatarUrl? item.avatarUrl.split(',') : [];
                            item.talentVideoUrl = item.talentVideoUrl? item.talentVideoUrl.split(',') : [];
                        })
                    } else {
                        this.data = null;
                        this.dataList = [];
                        this.$message.error(msg || '请求失败');
                    }
                })
                .catch(() => {
                    this.$message.error('请求错误');
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize
            };
            this.getDataList();
        },
        //预览图片
        previewImg(list,name) {
            this.photoList = list;
            this.photoName = name;
            this.photoListView = true;
        },
        // 播放视频
        playVideo(url) {
            this.$refs.videoPlay.show({ url: url });
        },
        //更多视频
        previewVideo(video,name) {
            this.vList = video;
            this.vName = name;
            this.vListView = true;
        },
        showDetail(row) {
            this.drawerData = row;
            this.drawerVisible = true;
        },
        async exportData() {
            this.exportLoading = true;
            const res = await this.$request({
                url: '/festival/springSeed/export',
                method: 'POST',
                data: {
                    ...this.params,
                    export: true
                }
            }).catch(() => {
                this.$message.error('导出请求失败');
            });

            if (!res) {
                this.exportLoading = false;
                return;
            }

            const { state, msg, result } = res.data;
            if (state == 1 && result) {
                const fileName = result?.fileName ? result.fileName+'.xlsx' : '春苗计划报名数据.xlsx';
                await downloadFileTmp(result.url, fileName);
            } else {
                this.$message.error(msg || '导出失败');
            }
            this.exportLoading = false;
        }
    }
}
</script>

<style lang="scss" scoped>
.video-cover {
    position: relative;
    cursor: pointer;
    width: 120px;
    height: 120px;

    &::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        left: 0;
        top: 0;
    }

    span {
        font-size: 30px;
        position: absolute;
        left: 50%;
        margin-left: -15px;
        top: 50%;
        margin-top: -15px;
        color: #fff;
        z-index: 1;
    }
}

.preview-box {
    .video-cover {
        display: inline-block;
        margin: 10px;
    }
}

.drawer-content {
    .detail-images {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;

        .detail-img {
            width: 120px;
            height: 120px;
        }
    }
    .detail-videos {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }
    .video-cover-sm {
        width: 80px;
        height: 80px;
        position: relative;
        cursor: pointer;
        background: #f5f5f5;
        border: 1px solid #e4e7ed;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
            font-size: 24px;
            color: #409eff;
        }
    }
}
</style>